import type { TargetExecutionStatus } from '@libs/enums';
import { Characters, ItemName, Locale, ValueSet } from '@ps-smart-cp/ppfw-client';

const TARGET_NAME_MAX_LEN = 80;

interface Schema {
  target: string;
  targetName: string;
  executionId: string;
  executionStatus: TargetExecutionStatus;
  executionStatusCondition: Set<TargetExecutionStatus>;
  outputFileKey: string | null;
  errorDetail: string | null;
}

interface Record {
  target: string;
  targetName: string;
  executionId: string;
  executionArn: string;
  executionStatus: string;
  executionStatusCondition: string[];
  outputFileKey: string | null;
  errorDetail: string | null;
}

const attributes = {
  target: Characters.preset.freeFormat({ maxLen: TARGET_NAME_MAX_LEN, required: true }),
  executionStatusCondition: ValueSet.new(),
};

const names = {
  maintenance: ItemName.of(
    [Locale.ja, 'ターゲットマスタメンテナンス'],
    [Locale.en, 'Target Master Maintenance'],
  ),
  register: ItemName.of([Locale.ja, 'ターゲットマスタ登録'], [Locale.en, 'Target Master Register']),
  change: ItemName.of([Locale.ja, 'ターゲットマスタ変更'], [Locale.en, 'Target Master Change']),
  detail: ItemName.of([Locale.ja, 'ターゲット詳細'], [Locale.en, 'Target Master Detail']),
  search: ItemName.of([Locale.ja, 'ターゲット検索'], [Locale.en, 'Target Search']),
  executionHistory: ItemName.of([Locale.ja, 'ターゲット実行履歴'], [Locale.en, 'Target Execution History']),

  creationDate: ItemName.of([Locale.ja, '作成日'], [Locale.en, 'Creation Date']),
  startDateCondition: ItemName.of([Locale.ja, '実行年月日'], [Locale.en, 'Execution Date']),
  target: ItemName.of([Locale.ja, 'ターゲット'], [Locale.en, 'Target']),
  targetName: ItemName.of([Locale.ja, 'ターゲット名'], [Locale.en, 'Target Name']),
  executionId: ItemName.of([Locale.ja, '実行ID'], [Locale.en, 'Execution ID']),
  executionStatus: ItemName.of([Locale.ja, 'ステータス'], [Locale.en, 'Status']),

  executionHistoryBtn: ItemName.of([Locale.ja, '実行履歴'], [Locale.en, 'Execution History']),
  selectTargetBtn: ItemName.of([Locale.ja, 'ターゲットを選択'], [Locale.en, 'select Target']),
};

export interface TargetMst {
  schema: Schema;
  record: Record;
}

export const targetMst = {
  attributes,
  names,
};
